import { SlideMasterProps } from '@features/powerpoint';
import { backgroundDark } from '../../images';

export const TITLE = 'DARK_BACKGROUND';

export const darkBackgroundSlideMaster = (
  shared: SlideMasterProps
): SlideMasterProps => ({
  ...shared,
  title: TITLE,
  background: { path: backgroundDark },
});
